// extracted by mini-css-extract-plugin
module.exports = {"market":"index-module--market--10lxt","change":"index-module--change--1Hpv9","marketLink":"index-module--marketLink--1bust"};